import customHeaders, { getSpace } from '../../common/headers';
import { useDataTable } from '../../common/hooks';
import { FilterContainer } from '../../components/FilterContainer/FilterContainer';
import { OlegHttps } from '../../fetchUrls';
import { useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import { ModalCreatingAnAdvertisingCampaignV2 } from '../../components/Modal/ModalCreatingAnAdvertisingCampaignV2/ModalCreatingAnAdvertisingCampaignV2';
import { ModalChoiceOfStrategyAnalyticalCollections } from '../../components/Modal/ModalCreatingAnAdvertisingCampaign/ModalChoiceOfStrategyAnalyticalCollections/ModalChoiceOfStrategyAnalyticalCollections';
import { fetchApiFilterVer3 } from '../../common/filtersFunc';
import {
  DropDownSelector,
  Tabs,
  RangeBox,
  TableBox,
  ButtonBasic,
} from '@lk-gtcom/ecomlab-components';
import { StepItem } from '../../components/StepItem/StepItem';
import useGeneralStore from '../../store/general';
import './AnalyticalCollectionsOzon.scss';
import { TitlePage } from '../../components/TitlePage/TitlePage';
import { getValueMultiFilter } from '../../common/filtersFunc';
import { RequestController } from '../../common/filtersFunc';
import { periodWeek } from '../../common/constant';
import { options_prop_mp } from '../../common/globalVariables';
import { useURLSearchParams } from '../../common/useURLSearchParams';
import { msToLocalDate } from '../../common/constant';
import { useSavedFilters } from '../../common/useSavedFilters';

const btn_tab = [
  {
    label: 'С низкой оборачиваемостью',
    value: 'low_turnover_rate',
    tooltip: (
      <p>
        Рассчитали медианное значение оборачиваемости товаров в днях по каждой
        категории площадки. В подборку добавлены товары с показателем выше
        медианного.
      </p>
    ),
  },
  {
    label: 'Высокая конверсия',
    value: 'high_conversion_rate',
    tooltip: (
      <p>
        Медианное значение конверсии из показа в заказ{' '}
        <span style={{ color: '#F97316' }}>10%</span> по выбранной площадке. В
        подборку добавлены товары с показателем выше медианного.
      </p>
    ),
  },
  {
    label: 'Недостаток трафика',
    value: 'insufficient_traffic',
    tooltip: (
      <p>
        Медианное значение количества показов на товар{' '}
        <span style={{ color: '#F97316' }}>10 шт.</span> по выбранной площадке.
        В подборку добавлены товары с показателем ниже медианного.
      </p>
    ),
  },
  {
    label: 'Товары без продаж',
    value: 'without_sales',
    tooltip: (
      <p>
        Медианное значение количество дней без продаж{' '}
        <span style={{ color: '#F97316' }}>10 </span> по выбранной площадке. В
        подборку добавлены товары с показателем выше медианного.'
      </p>
    ),
  },
  {
    label: 'CR в ЗАКАЗ выше медианы',
    value: 'analytical_collections_CR_to_order',
  },
  {
    label: 'CR в КОРЗИНУ выше медианы',
    value: 'analytical_collections_CR_to_cart',
  },
  {
    label: 'Ср.чек выше ср.чека среди товаров',
    value: 'analytical_collections_AOV',
  },
  {
    label: 'Есть на складе, нет продаж более 30 дней',
    value: 'analytical_collections_stock_without_sales',
  }
];

const AnalyticalCollectionsOzon = ({
  setShowTooltipParametr,
  setShowTooltipLauncAdvertisingCampaignInfo,
}) => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  // Сохранённые фильтры: подставляются в URL при заходе, запись по кнопке
  const { isReady, saveFilters, clearSavedFilters, isSaved, hasSavedFilters } = useSavedFilters(selectedSpace?.value, 'analytical-collections-ozon');
  // Реф для хранения контроллера запросов
  const requestControllerRef = useRef(new RequestController());
  const location = useLocation();
  const path = location?.pathname;

  const navigate = useNavigate();
  const [pageValue, setPageValue] = useState(btn_tab[0].value);
  const [range, setRange] = useState(0);

  // Дата
  const [date, setDate] = useState(periodWeek())
  const [dateFrom, dateTo] = date;

  // Таблица
  const [isTableRequest, setIsTableRequest] = useState(false);
  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(paginatorRef.current?.setTotal, paginatorRef);
  const { setLoading, setFetchedData, setHeaders, setSort } = setTableFuncs;


  // Фильтры
  const filterConfig = [
    { key: 'mp', type: 'multi' },
    { key: 'api', type: 'multi' },
    { key: 'category', type: 'multi' },
    { key: 'brand', type: 'multi' },
    { key: 'date_from', type: 'date' },
    { key: 'date_to', type: 'date' }
  ];
  const { urlParams, updateURL, isInitialized, hasInitialParams } = useURLSearchParams(filterConfig);
  const [isFilterRequest, setIsFilterRequest] = useState(false);

  const [apiData, setApiData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [brandData, setBrandData] = useState([]);

  const [selectedMarketplace, setSelectedMarketplace] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedApi, setSelectedApi] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedCategory, setSelectedCategory] = useState([{ label: 'Все', value: 'all' }]);
  const [selectedBrand, setSelectedBrand] = useState([{ label: 'Все', value: 'all' }]);

  const [totalApi, setTotalApi] = useState(0);
  const [totalCategory, setTotalCategory] = useState(0);
  const [totalBrand, setTotalBrand] = useState(0);

  const [apiPage, setApiPage] = useState(1);
  const [categoryPage, setCategoryPage] = useState(1);
  const [brandPage, setBrandPage] = useState(1);

  const [apiQuery, setApiQuery] = useState('');
  const [categoryQuery, setCategoryQuery] = useState('');
  const [brandQuery, setBrandQuery] = useState('');

  const [apiErr, setApiErr] = useState(false);
  const [marketplaceErr, setMarketplaceErr] = useState(false);

  const [chartData, setChartData] = useState([]);
  const [chartDataName, setChartDataName] = useState([]);
  const [chartLoading, setChartLoading] = useState(false);
  const [labels, setLabels] = useState([]);
  const [tooltip, setTooltip] = useState(true);

  const [currentStrategy, setCurrentStrategy] = useState(null);
  const [currentStrategyName, setCurrentStrategyName] = useState(null);
  const [currentStrategyNameForPortal, setCurrentStrategyNameForPortal] =
    useState(null);

  const [
    isModalCreatingAnAdvertisingCampaign,
    setIsModalCreatingAnAdvertisingCampaign,
  ] = useState(false);

  const [isModalChoiceOfStrategy, setIsModalChoiceOfStrategy] = useState(false);

  const [checkedProducts, setCheckedProducts] = useState([]);
  const [tableFetchParam, setTableFetchParam] = useState({});
  const [checkedErr, setCheckedErr] = useState(false);
  const [checkedStateEmpty, setCheckedStateEmpty] = useState(false);

  //tempIdTable
  const [tempIdTable, setTempIdTable] = useState(null);

  // Инициализация фильтров из URL параметров при первом рендере
  const [isInitialLoadFromURL, setIsInitialLoadFromURL] = useState(false);

  useEffect(() => {
    if (!isReady) return;
    if (!isInitialLoadFromURL) {
      setIsInitialLoadFromURL(true);

      // Обновляем все состояния фильтров
      setTimeout(() => {
        if (urlParams.mp) setSelectedMarketplace(urlParams.mp)
        if (urlParams.api) setSelectedApi(urlParams.api)
        if (urlParams.category) setSelectedCategory(urlParams.category)
        if (urlParams.brand) setSelectedBrand(urlParams.brand)
        if (urlParams.date_from) {
          setDate([
            new Date(parseInt(urlParams.date_from)),
            new Date(parseInt(urlParams.date_to)),
          ]);
        }

        // Запускаем запрос таблицы и фильтров только при первой инициализации из URL
        setIsFilterRequest(prev => !prev);
        if (Object.keys(urlParams).length > 0) {
          setIsTableRequest(prev => !prev);
        }
      }, 10);
    }
  }, [urlParams, isReady]);

  useEffect(() => {
    if (!isReady) return;
    updateURL({
      mp: urlParams?.mp || selectedMarketplace,
      api: urlParams?.api || selectedApi,
      category: urlParams?.category || selectedCategory,
      brand: urlParams?.brand || selectedBrand,
      date_from: urlParams?.date_from || dateFrom,
      date_to: urlParams?.date_to || dateTo,
    })
  }, [isReady]);


  const resetTable = () => {
    paginatorRef.current.reset();
    paginatorRef.current.setTotal(0);
    setCheckedProducts([]);
    setCheckedStateEmpty(true);
    setFetchedData([]);
    setHeaders([]);
    setSort({});
  };

  // Таблица
  const fetchTableData = (params, abortController = new AbortController()) => {
    if (!pageValue) return;

    setLoading(true);

    let sort, filtersParam;
    if (params) {
      [sort, filtersParam] = params;
    }

    const url = `${OlegHttps}/api/v2/api/v2/marketing/table/${pageValue}${sort?.length > 0
      ? '&order_param=' + sort[0] + '&order_param_direction=' + sort[1]
      : ''
      }`;

    const body = JSON.stringify({
      adv_campaign_type_list: ['all'],
      adv_status_list: ['all'],
      filters: filtersParam,
      category_id_list: getValueMultiFilter(selectedCategory),
      brand_id_list: getValueMultiFilter(selectedBrand),
      api_id_list: getValueMultiFilter(selectedApi),
      date_from: msToLocalDate(dateFrom),
      date_to: msToLocalDate(dateTo),
      offer_id_list: ['all'],
      order_param: sort?.[0],
      order_param_direction: sort?.[1],
      page: paginatorRef.current.page,
      limit: paginatorRef.current.limit,
    });

    setTableFetchParam(JSON.parse(body));

    fetch(url, { method: 'POST', headers, body, signal: abortController.signal })
      .then((res) => {
        if (res.status === 200) {
          return res.json();
        } else {
          throw new Error('bad table response');
        }
      })
      .then((json) => {
        setTable(json)
      })
      .catch((e) => console.error(e))
      .finally(() => {
        if (abortController.signal.aborted) return;
        setLoading(false)
      });
  };

  const returnTooltip = () => {
    const ind = btn_tab?.findIndex((el) => el?.value == pageValue);
    if (ind) {
      return btn_tab[ind]?.tooltip || '';
    }
  };

  useEffect(() => {
    setPageValue(btn_tab[0].value);
  }, []);

  useEffect(() => {
    setShowTooltipParametr(true);
    setShowTooltipLauncAdvertisingCampaignInfo(true);
    return () => {
      setShowTooltipParametr(false);
      setShowTooltipLauncAdvertisingCampaignInfo(false);
    };
  }, []);

  useEffect(() => {
    if (pageValue) {
      const currentTab = path?.split('/').at(-1);
      setPageValue(currentTab);
    }
  }, [path]);

  useEffect(() => {
    const rangeDate = (dateTo - dateFrom) / 86400000 + 1;
    setRange(rangeDate?.toString()?.split(',')?.slice(0, 1)?.join(''));
  }, [dateFrom, dateTo]);

  useEffect(() => {
    resetTable();
    if (!isReady) return;
    const abortController = new AbortController()
    fetchTableData([], abortController)
    return () => abortController.abort()
  }, [
    pageValue,
    dateFrom,
    dateTo,
    isTableRequest
  ]);

  const apiFilter = () => {
    const controller = requestControllerRef.current.createController('api');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      total: totalApi,
      page: apiPage,
      set: setApiData,
      searchParam: apiQuery,
      selectedApi,
      selectedShop: selectedMarketplace,
      setTotal: setTotalApi,
      filter: 'api_id',
    })?.finally(() => {
      requestControllerRef.current.removeController('api');
    })
  }

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    apiFilter()
  }, [apiPage, apiQuery, isFilterRequest]);

  const categoryFilter = () => {
    const controller = requestControllerRef.current.createController('category');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      total: totalCategory,
      page: categoryPage,
      apiData,
      selectedApi,
      set: setCategoryData,
      searchParam: categoryQuery,
      setTotal: setTotalCategory,
      filter: 'category',
    })?.finally(() => {
      requestControllerRef.current.removeController('category');
    })
  }

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    categoryFilter()
  }, [categoryPage, categoryQuery, isFilterRequest]);

  const brandFilter = () => {
    const controller = requestControllerRef.current.createController('brand');

    fetchApiFilterVer3({
      controller,
      selectedSpace: selectedSpace?.value,
      total: totalBrand,
      selectedApi,
      selectedCategory,
      page: brandPage,
      searchParam: brandQuery,
      selectedShop: selectedMarketplace,
      set: setBrandData,
      setTotal: setTotalBrand,
      filter: 'brand',
    })?.finally(() => {
      requestControllerRef.current.removeController('brand');
    })
  }

  useEffect(() => {
    if (!isInitialLoadFromURL) return;
    brandFilter()
  }, [brandPage, brandQuery, isFilterRequest]);

  useEffect(() => {
    return () => {
      // Отменяем все активные запросы фильтров
      requestControllerRef.current.abortAll();
    };
  }, []);


  const createTemp = () => {
    setChartData([]);
    setChartLoading(true);
    const url = `${'https://apps0.ecomru.ru:4141'}/tmp/table/create`;

    let marketplace_param = 1;
    // let marketplace_param = String(selectedMarketplace?.value);
    let table_name = pageValue;
    let param = tableFetchParam;
    let session_id = sessionStorage.getItem('session_id');
    // let product_id = checkedProducts?.map(({ SKU }) => SKU);
    let product_id = checkedProducts?.map(({ product_id }) => product_id);

    const body = JSON.stringify({
      table_name,
      marketplace_param,
      param,
      session_id,
      product_id,
    });

    fetch(url, { method: 'POST', headers, body })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          throw new Error(JSON.stringify(res.json()));
        }
      })
      .then((json) => {
        setTempIdTable(json?.tmp_campaign_id);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setChartLoading(false));
  };

  const onCreateAddHandler = (all = false) => {
    if (!selectedApi?.length > 0) {
      setApiErr(true);
      setTimeout(() => {
        setApiErr(false);
      }, 1000);
      return;
    }

    if (!selectedMarketplace?.length > 0) {
      setMarketplaceErr(true);
      setTimeout(() => {
        setMarketplaceErr(false);
      }, 1000);
      return;
    }

    if (!all) {
      if (!checkedProducts?.length > 0) {
        setCheckedErr(true);
        setTimeout(() => {
          setCheckedErr(false);
        }, 1000);
        return;
      }
    }

    createTemp();
    setIsModalCreatingAnAdvertisingCampaign(true);
  };

  useEffect(() => {
    if (!isModalCreatingAnAdvertisingCampaign) {
      if (!isModalChoiceOfStrategy) {
        localStorage.removeItem('campaignName');
        localStorage.removeItem('budget');
        localStorage.removeItem('date');
      }
    }
  }, [isModalCreatingAnAdvertisingCampaign]);

  const [resetTableChecked, setResetTableChecked] = useState(false);

  return (
    <>
      {isModalChoiceOfStrategy && (
        <ModalChoiceOfStrategyAnalyticalCollections
          setIsModal={(e) => setIsModalChoiceOfStrategy(e)}
          currentStrategy={currentStrategy}
          setCurrentStrategy={(e) => setCurrentStrategy(e)}
          setCurrentStrategyName={(e) => setCurrentStrategyName(e)}
          setIsModalCreatingAnAdvertisingCampaign={(e) =>
            setIsModalCreatingAnAdvertisingCampaign(e)
          }
          setCurrentStrategyNameForPortal={(e) =>
            setCurrentStrategyNameForPortal(e)
          }
        />
      )}

      {isModalCreatingAnAdvertisingCampaign && (
        <ModalCreatingAnAdvertisingCampaignV2
          dataTable={checkedProducts}
          selectedApi={selectedApi}
          selectedMarketplace={selectedMarketplace}
          selectedBrand={selectedBrand}
          selectedCategory={selectedCategory}
          currentStrategy={currentStrategy}
          currentStrategyName={currentStrategyName}
          currentStrategyNameForPortal={currentStrategyNameForPortal}
          setIsModalChoiceOfStrategy={(e) => setIsModalChoiceOfStrategy(e)}
          isModalChoiceOfStrategy={isModalChoiceOfStrategy}
          setIsModal={(e) => setIsModalCreatingAnAdvertisingCampaign(e)}
          tableDate={date}
          setDataTable={(e) => setCheckedProducts(e)}
          tablePageValue={pageValue}
          tempIdTable={tempIdTable}
          setResetTableChecked={setResetTableChecked}
        />
      )}

      <div className="analytical-collections">
        <TitlePage
          title='Аналитические подборки'
        />

        <div className="analytical-collections__filters">
          <FilterContainer
            loading={isSaved}
            saveFilters={saveFilters}
            clearSavedFilters={clearSavedFilters}
            hasSavedFilters={hasSavedFilters}
            onReset={(e) => {
              setSelectedMarketplace([]);
              setSelectedApi([]);
              setSelectedCategory([]);
              setSelectedBrand([]);
              updateURL({
                mp: null,
                api: null,
                category: null,
                brand: null,
              });
              setIsTableRequest(!isTableRequest)
              setIsFilterRequest(!isFilterRequest)
            }}
          >
            <DropDownSelector
              err={marketplaceErr}
              options_prop={options_prop_mp}
              state={selectedMarketplace}
              setState={setSelectedMarketplace}
              placeholder="Маркетплейс"
              multi
              total={options_prop_mp?.length}
              onBlur={() => {
                updateURL({ mp: selectedMarketplace });
                apiFilter()
                brandFilter()
                categoryFilter()
                setIsTableRequest(!isTableRequest)
              }}
            />

            <DropDownSelector
              err={apiErr}
              state={selectedApi}
              options_prop={apiData}
              setState={setSelectedApi}
              placeholder="Площадка"
              total={totalApi}
              fetchCallback={setApiPage}
              setInputChange={setApiQuery}
              multi
              onBlur={() => {
                updateURL({ api: selectedApi });
                brandFilter()
                categoryFilter()
                setIsTableRequest(!isTableRequest)
              }}
            />
            <DropDownSelector
              state={selectedCategory}
              options_prop={categoryData}
              setState={setSelectedCategory}
              placeholder="Категория"
              total={totalCategory}
              fetchCallback={setCategoryPage}
              setInputChange={setCategoryQuery}
              multi
              onBlur={() => {
                updateURL({ category: selectedCategory });
                brandFilter()
                setIsTableRequest(!isTableRequest)
              }}
            />
            <DropDownSelector
              state={selectedBrand}
              options_prop={brandData}
              total={totalBrand}
              setState={setSelectedBrand}
              placeholder="Бренд"
              fetchCallback={setBrandPage}
              setInputChange={setBrandQuery}
              multi
              onBlur={() => {
                updateURL({ brand: selectedBrand });
                setIsTableRequest(!isTableRequest)
              }}
            />
          </FilterContainer>

          <RangeBox
            date={date}
            setDate={(e) => {
              const [newDateFrom, newDateTo] = e;
              updateURL({
                date_from: newDateFrom,
                date_to: newDateTo
              });
              setDate(e)
            }}
          />
        </div>

        <Tabs
          tabs={btn_tab}
          pageValue={pageValue}
          query={location?.search}
        />

        {tooltip && returnTooltip() && (
          <StepItem
            title={returnTooltip()}
          />
        )}

        <TableBox
          onCheck={(e) => setCheckedProducts(e)}
          ref={paginatorRef}
          paginator={true}
          fetchCallback={fetchTableData}
          setCheckedStateEmpty={
            checkedStateEmpty ? (e) => setCheckedStateEmpty(e) : false
          }
          onUncheckAllDependence={[pageValue, resetTableChecked]}
          {...tableProps}
          child={
            <>
              <ButtonBasic
                green
                text={`Создать кампанию со всеми товарами - ${tableProps?.total}`}
                // onClick={(e) => onCreateAddHandler(true)}
                width="370px"
                size="32px"
              />

              <ButtonBasic
                lilac
                disabled={!checkedProducts?.length > 0}
                text={`Создать кампанию с выбранными товарами - ${checkedProducts?.length > 0 ? checkedProducts?.length : '0'
                  }`}
                onClick={(e) => onCreateAddHandler()}
                width="370px"
                size="32px"
              />
            </>
          }
        />
      </div>
    </>
  );
};

export { AnalyticalCollectionsOzon };
